import ModalRequest from './modalRequest/modalRequest';
import ModalCalendarGrid from './modalCalendarGrid/modalCalendarGrid';
import ModalRemovePeriod from './modalRemovePeriod/modalRemovePeriod';
import WarningRequestVacation from './warningRequestVacation/warningRequestVacation';

let componentModule = angular.module('vacations-absences.components.modals', [
  ModalRequest,
  ModalCalendarGrid,
  ModalRemovePeriod,
  WarningRequestVacation,
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modals.js